// import { ConfigMurucaResourceLayout } from '@net7/boilerplate-muruca';

export default {
  maxHeight: 100, // Threshold where the "read-more" button appears
  title: '',
  tabs: 'project',
  type: 'project',
  sections: {
    top: [
      // {
      //   id: 'breadcrumbs-project',
      //   type: 'breadcrumbs',
      //   options: {
      //     base: [{
      //       title: 'global#home',
      //       link: '/'
      //     }]
      //   }
      // },
      {
        id: 'header',
        type: 'title',
        grid: null,
      },
      {
        id: 'tab-bar',
        type: 'tabs',
      },
    ],
    content: [
      {
        id: 'parallel-text-viewer',
        type: 'parallel-text-viewer',
        options: {
          searchId: 'xml_text',
          grid: {
            panels: [0],
          },
          panels: [
            {
              id: "panel2",
              view: "single",
            },
          ],
          libOptions: {
            pbPage: {
              urlIgnore: 
                [
                  //  "highlight1,odd,view,path,selectors,highlight,view2"
                ],
            },
            toc: {
              disable: true,
            },
            grid: {
              disableAddColumn: true,
            }
          },
        },
      },
    ],
  },
};
